export default "__VITE_ASSET__DEdaeU9d__"